import React from "react";
import "./WhyKarmaDelta.css";

const values = [
  "AI with business context — not technology for its own sake",
  "Strategy with execution discipline — from vision to implementation",
  "Marketing grounded in insight — not guesswork",
  "Flexible advisory model — for startups, growing firms, and established businesses",
  "Innovation-oriented perspective — especially in emerging technology and new business models"
];

const WhyKarmaDelta = () => {
  return (
    <section className="why-section">
      <div className="container why-container">

        <div className="why-left">
          <h2>Why Karma & Delta</h2>
          <p>
            A selective, expert-driven advisory approach built around clarity,
            execution discipline, and long-term thinking.
          </p>
        </div>

        <div className="why-right">
          {values.map((item, index) => (
            <div key={index} className="why-item">
              <span className="why-dot"></span>
              <p>{item}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyKarmaDelta;